// extracted by mini-css-extract-plugin
export default {"links":"hqVEwuL_d6TsKxgeN6uU"};